export default "__VITE_ASSET__wXYrXSfL__"